export const GET_EXPENSE_REPORTS_LIST = "GET_EXPENSE_REPORTS_LIST";
export const GET_EXPENSE_REJECT_TYPES = "GET_EXPENSE_REJECT_TYPES";
export const GET_EXPENSE_REPORTS_WEEKLY = "GET_EXPENSE_REPORTS_WEEKLY";
export const GET_EXPENSE_REPORTS_USER_WEEKLY = "GET_EXPENSE_REPORTS_USER_WEEKLY";
export const GET_USERS_SECTORS = "GET_USERS_SECTORS";

export const getExpenseReportsList = params => {
  return { type: GET_EXPENSE_REPORTS_LIST, payload: params };
};

export const fetchExpenseReportsWeekly = params => {
  return { type: GET_EXPENSE_REPORTS_WEEKLY, payload: params };
};

export const fetchExpenseReportsUserWeekly = params => {
  return { type: GET_EXPENSE_REPORTS_USER_WEEKLY, payload: params };
};

export const getExpenseRejectTypes = () => {
  return { type: GET_EXPENSE_REJECT_TYPES };
};

export const fetchUsersSectors = params => {
  return { type: GET_USERS_SECTORS, payload: params };
};



// WEBPACK FOOTER //
// src/modules/presence/actions/expenseReports.js